var _a;
import { initSDK, page, session, user } from "@embrace-io/web-sdk";
initSDK({
    appID: "ivoh0",
});
page.setPageLabel(((_a = window.LUX) === null || _a === void 0 ? void 0 : _a.label) || "Unlabelled Page");
const scConf = window.SPEEDCURVE_CONFIG;
session.addProperty("teamId", scConf.accountId);
session.addProperty("teamTimeZone", scConf.accountTimezone);
session.addProperty("teamHasRum", String(scConf.accountHasRum));
session.addProperty("teamHasRumData", String(scConf.accountHasRumData));
if (scConf.userId) {
    user.setUserId(scConf.userId);
}
